<template lang="pug">
v-dialog(
  dark
  v-model='dialog'
  width="90vw"
  max-width="700px"
  transition="dialog-bottom-transition"
)
  template(v-slot:activator="{on}")
    v-tooltip(bottom) Добавить инструкцию
      template(#activator="{ on: toolOn}")
        v-btn(color="accent" v-on="{...on, ...toolOn}")
          v-icon mdi-book-plus
  v-card.pa-4
    p.title Выберите инструкцию
    v-autocomplete(
      :loading="loading"
      placeholder="Начните вводить название"
      v-model="inputValue"
      filled
      :items="nstructions"
      item-text="name"
      item-value="instruction"
      return-object
      :search-input.sync="searchValue"
    )
      template(#item="data")
        v-list(width="600px")
          v-list-item
            span.py-2 {{ data.item.name }}

    v-btn.mr-2(color="success" :disabled="!inputValue" @click="submit") Добавить
    v-btn.mr-2(color="primary" @click="openInstructionPdf" :disabled="!inputValue") Открыть
    v-btn(@click="dialog = false" text) Отменить
</template>

<script>
import directoryService from '@/services/API/_directory';
// import uriToFile from '@/lib/uriToFile';
import debounce from 'lodash/debounce';

export default {
  name: 'SelectInscturctions',
  props: {
    projectId: { type: Number, required: true },
  },
  data() {
    return {
      loading: false,
      searchValue: '',
      inputValue: null,
      dialog: false,
      nstructions: [],
      projectInstructions: [],
    };
  },
  watch:{
    searchValue: debounce(function () {
      this.fetchPFDOInstructions();
    }, 500),
  },
  created() {
    // this.fetchProjectInstructions();
    this.fetchPFDOInstructions();
  },
  methods: {
    // async fetchProjectInstructions() {
    //   const response = await directoryService.getServiceHelps({ 'expand': 'pdf_url' });
    //   this.projectInstructions = [...this.projectInstructions, ...response.data.data];
    // },
    async fetchPFDOInstructions() {
      const params =  { 'expand': 'pdf_url', 'search[name]':this.searchValue };
      this.loading = true;
      const response = await directoryService.getHelps(params);
      this.nstructions = [...this.nstructions, ...response.data.data];
      this.loading = false;
    },
    openInstructionPdf() {
      window.open(this.inputValue.pdf_url, '_blank');
    },
    submit() {
      this.$emit('get-pdf', this.inputValue);
      // console.log(this.inputValue.pdf_file);
      // console.log(uriToFile(`'data:application/pdf;base64,${this.inputValue.pdf_file}`));
      this.dialog = false;
      this.inputValue = null;
    },
  },
};
</script>

<style>

</style>
